export const stylesColorConfig = {
  blue: '#22429A',
  'dark-blue': '#0b2366',
  'light-blue': '#5B78C6',
  'over-light-blue': '#89A5F1',
  red: '#cf2803',
  'dark-red': '#8f1a00',
  'light-red': '#ffe3dd',
  yellow: '#ffdf17',
  'dark-yellow': '#f0bb00',
  sand: '#faf6e2',
  black: '#000000',
  white: '#ffffff',
  'sky-blue': '#E8F0FF',
  'dark-sky-blue': '#C0D5FD',
  grey: '#909090',
  graphite: '#52545C',
  'middle-grey': '#E0E0E0',
  'light-grey': '#F4F4F4',
  's-terracotta': '#B63831',
  's-magenta': '#9F2757',
  's-purple': '#612194',
  's-steel': '#3375B8',
  's-sea': '#39818D',
  's-grass': '#2C675C',
  's-olive': '#618A3D',
  's-orange': '#EDAC46',
  's-peach': '#DF742C',
  's-carrot': '#D5562E',
  's-chocolate': '#4A352F',
  's-asphalte': '#3A474E',
  'msp-primary': '#044B76',
  'msp-secondary': '#2A658b',
  'msp-light-blue': '#8692AC',
};
